/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconDone = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--done',
    className,
  )

  return (
    <IconBase className={classes} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"{...rest}><path className="path1" fillRule="evenodd" clip-rule="evenodd" d="M0 10C0 4.48 4.48 0 10 0s10 4.48 10 10-4.48 10-10 10S0 15.52 0 10zm3 0l5 5 9-9-1.41-1.42L8 12.17 4.41 8.59 3 10z" fill="#86BD24"/></IconBase>
  )
}

IconDone.propTypes = {
  className: PropTypes.string,
}

export default IconDone
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconDone.js